import { DomSanitizer,SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser'
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'safeHtml',
    standalone: false
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitize: DomSanitizer) {

  }
  transform(value: any, type?: any): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
			case 'html': return this.sanitize.bypassSecurityTrustHtml(value);
			case 'style': return this.sanitize.bypassSecurityTrustStyle(value);
			case 'script': return this.sanitize.bypassSecurityTrustScript(value);
			case 'url': return this.sanitize.bypassSecurityTrustUrl(value);
			case 'resourceUrl': return this.sanitize.bypassSecurityTrustResourceUrl(value);
			default: throw new Error(`Invalid safe type specified: ${type}`);
		}
  }
}
